export default function(container, element) {
  if (container.width <= 0 || container.height <= 0) {
    return { x: 0, y: 0 }
  }

  const x = container.width / 2 - element.width / 2
  const y = container.height / 2 - element.height / 2

  return {
    x: Math.ceil(x),
    y: Math.ceil(y),
  }
}



// WEBPACK FOOTER //
// ./src/utils/calcCenter.js